import React from 'react';
import { nullFn } from '../utils';

type BaseCheckboxProps = {
  name: string;
  checked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  onClick?: (e: React.MouseEvent) => void;
};

const BaseCheckbox = ({
  name,
  checked = false,
  disabled = false,
  indeterminate = false,
  onClick = nullFn,
}: BaseCheckboxProps): JSX.Element => {
  const setCheckboxRef = (checkbox: HTMLInputElement) => {
    if (checkbox) {
      checkbox.indeterminate = indeterminate;
    }
  };

  return (
    <label htmlFor={name}>
      <input
        className='form-checkbox cursor-pointer outline-none rounded-md w-5 h-5 text-green border-gray-light ring-0 focus:ring-0 focus:ring-offset-0 focus:outline-none focus:outline-offset-0 focus:shadow-none'
        type='checkbox'
        ref={setCheckboxRef}
        id={name}
        name={name}
        aria-label={name}
        checked={checked}
        disabled={disabled}
        onClick={disabled ? nullFn : onClick}
        onChange={nullFn}
      />
    </label>
  );
};

export default React.memo(BaseCheckbox);
